import { madisonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function MadisonPage() {
  return <CityPageTemplate config={madisonConfig} />;
}